























import { Component, Prop, Vue } from 'vue-property-decorator';


import Button from '../../engine/Button';

@Component({
    components: {
    },
})
export default class RoomButtonVue extends Vue {

    @Prop() private button!: Button;

    click(){
        this.button.click(false);
    }

}

